import axios, { AxiosInstance } from 'axios';
import { getApiUrl } from '@/config/env';

const axiosClient: AxiosInstance = axios.create({
  baseURL: getApiUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosClient;
